export const useSessionStorage = () => {
  const setItem = <T>(key: string, value: T): void => {
    try {
      const serialized = JSON.stringify(value);
      sessionStorage.setItem(key, serialized);
    } catch (err) {
      console.error("Failed to set sessionStorage item:", err);
    }
  };

  const getItem = <T>(key: string): T | null => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (err) {
      console.error("Failed to parse sessionStorage item:", err);
      return null;
    }
  };

  const removeItem = (key: string): void => {
    sessionStorage.removeItem(key);
  };

  const clear = (): void => {
    sessionStorage.clear();
  };

  return {
    setItem,
    getItem,
    removeItem,
    clear,
  };
};
